<script setup>
import {computed} from 'vue';
const siteUrl = document.querySelector('meta[name="site-url"]').content;

const props = defineProps({
  currentPage: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
});
const emits = defineEmits(['move-paginate']);

// 端以外のページ番号を取得
const middlePages = computed(() => {
  const pages = [];
  for (let i = props.currentPage - 3; i < props.currentPage + 4; i++) {
    if (i < 1 || i > props.total) {
      continue;
    }
    pages.push(i);
  }
  return pages;
});
</script>

<template>
  <ol class="lyHorizontalCnt">
    <li
      v-if="currentPage > 1"
      class="modPagenationListItem"
    >
      <button
        class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink"
        @click="$emit('move-paginate', 1)"
      >
        <img
          :src="siteUrl+'images/pagenationArrowFirst.svg'"
          width="34"
          height="34"
          loading="lazy"
          alt="最初へ"
        >
      </button>
    </li>
    <li
      v-if="currentPage > 1"
      class="modPagenationListItem"
    >
      <button
        class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink"
        @click="$emit('move-paginate', currentPage - 1)"
      >
        <img
          :src="siteUrl+'images/pagenationArrowPrev.svg'"
          width="34"
          height="34"
          loading="lazy"
          alt="前へ"
        >
      </button>
    </li>
    <li
      v-if="currentPage > 4"
      class="modPagenationListItem"
    >
      <button
        class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink js-paginateLink"
        @click="$emit('move-paginate', 1)"
      >1</button>
    </li>
    <li
      v-if="currentPage > 5"
      class="modPagenationListItem mdNotBtn"
    >
      <p class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink">...</p>
    </li>
    <li
      v-for="page in middlePages"
      :key="page"
      :class="{modPagenationListItem: true, isCurrent: page === currentPage}"
    >
      <button
        class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink"
        @click="$emit('move-paginate', page)"
      >{{page}}</button>
    </li>
    <li
      v-if="currentPage < (total - 4)"
      class="modPagenationListItem mdNotBtn"
    >
      <p class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink">...</p>
    </li>
    <li
      v-if="currentPage < (total - 3)"
      class="modPagenationListItem"
    >
      <button
        class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink"
        @click="$emit('move-paginate', total)"
      >{{total}}</button>
    </li>
    <li
      v-if="currentPage < total"
      class="modPagenationListItem"
    >
      <button
        class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink"
        @click="$emit('move-paginate', currentPage + 1)"
      >
        <img
          :src="siteUrl+'images/pagenationArrowNext.svg'"
          width="34"
          height="34"
          loading="lazy"
          alt="次へ"
        >
      </button>
    </li>
    <li
      v-if="currentPage < total"
      class="modPagenationListItem"
    >
      <button
        class="lyHvCnt lyW100 lyLh100 pFontBold pFontBlack modPagenationListLink"
        @click="$emit('move-paginate', total)"
      >
        <img
          :src="siteUrl+'images/pagenationArrowLast.svg'"
          width="34"
          height="34"
          loading="lazy"
          alt="最後へ"
        >
      </button>
    </li>
  </ol>
</template>
